const URL_TYPES = {
  ASSET: 'ASSET',
  HUB: 'HUB',
};

const ASSET_LIB_LINKS = {
  [URL_TYPES.ASSET]: (assetId: string) => `/new/ui/assets/asset/${assetId}`,
  [URL_TYPES.HUB]: (hubId: string) => `/new/ui/assets/hub/${hubId}`,
};

// only assets supported for now
function getAssetLibAccessLinkGenerator({
  type = URL_TYPES.ASSET,
  id,
}: {
  type?: string;
  id: string;
}) {
  return ASSET_LIB_LINKS[type](id);
}

export default getAssetLibAccessLinkGenerator;

export { URL_TYPES };
